"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUIZ_OWNER_TYPE = void 0;
exports.QUIZ_OWNER_TYPE = {
    MERCHX: 'MERCHX',
    CUSTOMER: 'CUSTOMER'
};
//# sourceMappingURL=quizOwner.js.map